module.exports = __webpack_public_path__ + "static/media/bmw_apps_search.5e0cfc45.svg";